export default function CTASection() {
  return (
    <section id="cta" className="relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[360px] md:min-h-[480px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20items%20and%20accessories%20artfully%20arranged%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20lighting%20from%20left%2C%20sage%20green%20and%20cream%20color%20palette%2C%20minimalist%20editorial%20photography%2C%20warm%20atmosphere%20with%20organic%20composition%20and%20gentle%20shadows&width=900&height=600&seq=cta-left-usfans-v2j55p&orientation=landscape"
            alt="USFansSpreadsheet store"
            className="absolute inset-0 w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/25"></div>
          <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-12">
            <p className="text-xs md:text-sm font-medium text-white/85 uppercase tracking-wider font-label">
              Przejdź do sklepu
            </p>
            <div>
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight drop-shadow-md">
                Zobacz
                <br />
                USFansSpreadsheet
                <br />
                na żywo
              </h2>
            </div>
          </div>
        </div>

        <div className="bg-background-50 flex items-center justify-center py-12 md:py-16 px-6 md:px-12">
          <div className="max-w-md text-center">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-6">
              Gotowy na
              <br />
              zakupy?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Odwiedź nasz główny sklep Kaspreadsheet i odkryj pełną kolekcję produktów. Ponad 14 kategorii, setki produktów i najlepsze ceny w jednym miejscu.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                usfans spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                buy it now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}